import { mapActions, mapGetters } from 'vuex';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import plusMinusSign from '@/components/generics/plus-minus-sign/plus-minus-sign.vue';
import { toCents } from '@/utils/helpers';


export default {
  props: {
    confirmationData: {
      type: Object,
      required: true,
    },
  },
  components: {
    alertBox,
    plusMinusSign,
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    pricePerShare() {
      return `${toCents(this.confirmationData.pricePerShare)}¢`;
    },
    tradeTypeText() {
      return this.confirmationData.tradeType <= 1 ? 'Buy' : 'Sell';
    },
    priceText() {
      const prefix = this.confirmationData.tradeType <= 1 ? 'Max' : 'Min';
      return `${prefix} Price`;
    },
    tradeTypeClass() {
      return {
        'purchase-review-and-confirm__contract-single-share': true,
        'purchase-review-and-confirm__contract-single-share--yes':
          this.confirmationData.tradeType === 1 || this.confirmationData.tradeType === 3,
        'purchase-review-and-confirm__contract-single-share--no':
          this.confirmationData.tradeType === 0 || this.confirmationData.tradeType === 2,
      };
    },
    profits() {
      return this.confirmationData.tradeProfit || 0;
    },
    fees() {
      return this.confirmationData.fee || null;
    },
    riskAdjustment() {
      return this.confirmationData.estimatedRisk || null;
    },
    orderTotal() {
      return this.confirmationData.orderTotal;
    },
    showProfitOrLoss() {
      const types = [2, 3];
      const tradeType = this.confirmationData.tradeType;
      return (this.profits !== 0) || (types.includes(tradeType));
    },
    profitOrLoss() {
      const profit = this.profits || 0;
      return (profit > 0) ? 'Profit' : 'Loss';
    },
    dashboardClass() {
      return {
        'purchase-review-and-confirm--dashboard': this.$route.name === 'portfolio',
      };
    },
  },
  methods: {
    ...mapActions('trade', ['setConfirmationToggle']),
    cancel() {
      this.setConfirmationToggle(true);
      this.$emit('cancel');
    },
    submit() {
      this.$emit('submit');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/purchase-review-and-confirm/purchase-review-and-confirm.js